import { render, staticRenderFns } from "./SubProducts.vue?vue&type=template&id=1fa56fc4"
import script from "./SubProducts.vue?vue&type=script&lang=js"
export * from "./SubProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa56fc4')) {
      api.createRecord('1fa56fc4', component.options)
    } else {
      api.reload('1fa56fc4', component.options)
    }
    module.hot.accept("./SubProducts.vue?vue&type=template&id=1fa56fc4", function () {
      api.rerender('1fa56fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubProducts.vue"
export default component.exports